import React from "react";
import PropTypes from "prop-types";

import styles from "./Fees.module.css";
import getFullAmount from "./getFullAmount";
import { obfuscateAmount } from "utils";
import FeatureRenderer from "components/Feature/RendererContainer";

const fullAmountIsNotZero = feeDesc => getFullAmount(feeDesc) !== 0;

const FeeGroup = ({ title, feesAmount }) => {
  return (
    <li>
      <p className={styles.feeGroupLabel} id={`section_${title}`}>{title}</p>
      <ul className={styles.subList}>
        {feesAmount.filter(fullAmountIsNotZero).map((fa, i) => (
          <li key={`${i}-${fa.sequence}`}>
            <p className={styles.item}>
              <span className={styles.feesLabel} id={`${fa.helpText}_label`}>{fa.helpText}</span>
              <FeatureRenderer feature="FeeReportGeneration">
                <span className={styles.paid} id={`${fa.helpText}_fullamount`} >{fa.fullAmount}</span>
                <span className={styles.refunded} id={`${fa.helpText}_proratedAmount`}>{fa.proratedAmount}</span>
              </FeatureRenderer>
              <FeatureRenderer
                feature="FeeReportGeneration"
                value={false}
                showUnset>
                <span className={`${styles.paid} ${styles.blurred}`}>
                  {obfuscateAmount(fa.fullAmount)}
                </span>
                <span className={`${styles.refunded} ${styles.blurred}`}>
                  {obfuscateAmount(fa.proratedAmount)}
                </span>
              </FeatureRenderer>
            </p>
          </li>
        ))}
      </ul>
    </li>
  );
};

FeeGroup.propTypes = {
  title: PropTypes.string.isRequired,
  feesAmount: PropTypes.array.isRequired
};

export default FeeGroup;
